import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { UserRFC } from 'types';

type Data = Array<UserRFC>;

type Payload = {
  companyId?: string;
};

export const companyRfcsFetch = createApiSlice<Data, Payload>({
  name: 'companyRfcsFetch',
  *tryGenerator(_, { payload: { companyId } }) {
    const url = companyId
      ? getEndpointV2({ path: '/auth/company/:companyId/rfc', urlParams: { companyId } })
      : getEndpointV2({ path: '/auth/company/rfc' });

    const { data } = yield call(amplifyClient, {
      method: 'get',
      url,
    });

    return data;
  },
});
